<template>
  <div class="yunxiao teacher share-page" data-test="shara-page">
    <div class="top"></div>
    <div class="block-infos common"></div>
    <div class="block-infos types" :class="{ 'is-culture': isCultureType }"></div>
    <page-footer-btn multipleBtns>
      <van-button
        type="primary"
        block
        square
        round
        @click="app.x3.picker.notifyBindAccount()"
        data-test="shara-page-btn-show"
        >分享给家长</van-button
      >
    </page-footer-btn>
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'Share',
  data() {
    return {
      pageTitle: '小云爱学',
      show: false,
    };
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
    // 是否为产品规定的文化类
    // 文化类和非文化类展示会有区别
    // http://axure.xiaogj.com/zzl/yunxiao/v1.14/#id=8gm2m0&p=%E6%9C%BA%E6%9E%84%E7%AB%AF%E5%BC%95%E5%AF%BC&g=1
    isCultureType() {
      let cultureTypeKeys = { 1: true, 2: true, 9: true, 14: true, 15: true, 99: true };
      let customerTypeList =
        app.tool.safeReadObjProp(this, 'userInfo.companyInfoVo.customerTypeList') || [];
      for (let type of customerTypeList) {
        if (cultureTypeKeys[type.customerTypeId]) return true;
      }
      return false;
    },
    notProductEnv() {
      // 本地开发环境
      if (app.tool.safeReadObjProp(process, 'env.NODE_ENV') === 'development') {
        return true;
      }

      // 生产开发、测试环境
      let hostname = location.hostname;
      if (/^x3-(dev)|(test)|(sit)/.test(hostname)) {
        return true;
      }
      return false;
    },
  },
  methods: {
  },
  components: {
    pageFooterBtn,
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.share-page {
  padding-bottom: calc(var(--gap) * 50);
  background: var(--g1);
  .top {
    height: 127px;
    background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0020.png)
      center/cover no-repeat;
  }
  .block-infos {
    position: relative;
    margin: 0 16px 18px;
    border-radius: var(--radius-sm);
    background: var(--white);
    &::before {
      position: absolute;
      content: '';
      display: block;
      left: 0;
      right: 0;
      top: -7px;
      margin: 0 auto;
      width: 181px;
      height: 39px;
      background: transparent url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0021.png)
        center/cover no-repeat;
    }
    &.common {
      margin-top: -7px;
      border: 1px solid var(--white);
      &::after {
        content: '';
        display: block;
        margin: 51px auto 26px;
        width: 285px;
        height: 204px;
        background: transparent
          url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0023.png?_t_=1624501997743)
          center/cover no-repeat;
      }
    }
    &.types {
      &::before {
        background: transparent
          url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0022.png) center/cover
          no-repeat;
      }
      &::after {
        content: '';
        display: block;
        margin: 16px auto;
        width: 311px;
        height: 805px;
        background: transparent
          url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0025.png) center/cover
          no-repeat;
      }
    }
    &.types.is-culture::after {
      background-image: url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0024.png);
    }
  }
  .footer {
    position: fixed;
    // padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    bottom: 0;
    left: 0;
    right: 0;
    // height: calc(var(--w) * 54);
    // background-color: var(--white);
  }
  .share-content {
    .title,
    .tips {
      margin: calc(var(--gap) * 20) auto calc(var(--gap) * 34);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      font-weight: 400;
      text-align: center;
    }
    .img-nav {
      position: relative;
      margin: auto;
      height: 354px;
      width: 241px;
      > img {
        outline: none;
        border: none;
        width: 100%;
        height: 100%;
      }
      .preview-tips {
        position: absolute;
        bottom: 0;
        right: 0;
        color: var(--white);
        padding: calc(var(--gap) * 5) calc(var(--gap) * 11);
        border-radius: var(--radius-sm) 0 var(--radius-sm) 0;
        background: rgba(var(--black-rgb), 0.8);
        opacity: 0.9;
      }
    }
    .tips {
      margin: calc(var(--gap) * 8) auto calc(var(--gap) * 24);
      color: var(--g6);
    }
  }
}
</style>
<style lang="scss">
.van-image-preview.share-poster-preview {
  padding: 0 16px;
}
</style>